export default function integer() {

    function integerCount(e) {
        let $this = $(this),
            $inputParent = $this.parents('.integer-line'),
            numberVal = $this.val(),
            maxCount = $this.attr('max'),
            minCount = $this.attr('min');


        if (numberVal >= parseInt(maxCount)) {
            $inputParent.addClass('integer-line--disabled-plus');
            $this.val(maxCount);
        }
        if (numberVal <= parseInt(minCount)) {
            $inputParent.addClass('integer-line--disabled-minus');
            $this.val(minCount);
        }

        if (numberVal < maxCount) {
            $inputParent.removeClass('integer-line--disabled-plus');
        }
        if (numberVal > minCount) {
            $inputParent.removeClass('integer-line--disabled-minus');
        }

        if (e.keyCode === 188) {
            e.preventDefault();
        }
    }

    function integerShiftCount(e) {
        let $inputNumber = $(this).parents('.integer-input').find('.integer-quantity'),
            $inputParent = $(this).parents('.integer-line'),
            numberVal = $inputNumber.val(),
            number = parseInt(numberVal),
            maxCount = $inputNumber.attr('max'),
            minCount = $inputNumber.attr('min');

        if (e.shiftKey) {

            if ($(this).hasClass('integer-controls--plus')) {
                number = number + 9;
                $inputNumber.val(number);

                if (numberVal >= maxCount || numberVal >= maxCount - 9) {
                    $inputNumber.val(maxCount);
                    $inputParent.addClass('integer-line--disabled-plus');
                }
            }

            if ($(this).hasClass('integer-controls--minus')) {
                number = number - 9;
                $inputNumber.val(number);

                if (numberVal <= minCount || numberVal <= 9) {
                    $inputNumber.val(minCount);
                    $inputParent.addClass('integer-line--disabled-minus');
                }
            }
        }

        if (numberVal === maxCount) {
            $inputParent.addClass('integer-line--disabled-plus');
        }
        if (numberVal === minCount) {
            $inputParent.addClass('integer-line--disabled-minus');
        }

        if (numberVal < maxCount) {
            $inputParent.removeClass('integer-line--disabled-plus');
        }
        if (numberVal > minCount) {
            $inputParent.removeClass('integer-line--disabled-minus');
        }
    }

    $('.integer-controls').on('click', integerShiftCount);

    $('.integer-quantity').on('input keyup', integerCount);

    $('.integer-quantity').on('click', function () {
        $(this).select();
    });

}